import "./App.css";
import PaletteApp from "./components/palette/PaletteApp";

function App() {
  return (
    <div className="App">
      <PaletteApp />
    </div>
  );
}

export default App;
